import classNames from 'classnames';
// import PropTypes from 'prop-types';
import React from 'react';
import {prefix} from '../../wui-core/src/config/updatePrefix';
import type {InputGroupAddonProps} from './iInputGroup'

const InputGroupAddon = React.memo(
    React.forwardRef<HTMLSpanElement, InputGroupAddonProps>((props, ref) => {
        const {className, clsPrefix, addonType, ...others} = props;
        const resolvedClsPrefix = clsPrefix || (addonType === 'button' ? `${prefix}-input-group-btn` : `${prefix}-input-group-addon`);
        const mergedClassName = React.useMemo(() => classNames(className, resolvedClsPrefix), [className, resolvedClsPrefix]);

        return <span ref={ref} {...others} className={mergedClassName} />;
    })
);

InputGroupAddon.displayName = 'InputGroupAddon';

export default InputGroupAddon;
